import getObjectPathProperty from "./getObjectPathProperty";
export default function setResultInObjectByPath(target, pathResult, data) {
    if(!getObjectPathProperty(target, pathResult)) {
        return;
    }
    const properties = pathResult.split('.');
    let obj = target, lengthProp = properties.length - 1;
    for(let i = 0; i < lengthProp; i++) {
        if (typeof obj[properties[i]] === 'object') {
            obj = obj[properties[i]];
        } else {
            return;
        }
    };

    if(obj !== undefined && obj[properties[lengthProp]]){
        obj[properties[lengthProp]] = data;
    }
}
